module.exports = __webpack_public_path__ + "static/media/erase.c43f0753.gif";